import { createFileRoute, notFound } from "@tanstack/react-router";
import { getBlogPost } from "@/content/blog";
import { BlogPostView } from "@/components/blog/BlogPostView";
import { pageMeta, ldScripts, blogPostingLd, breadcrumbLd } from "@/lib/seo";
import { siteConfig } from "@/config/site";


export const Route = createFileRoute("/$slug")({
  loader: async ({ params }) => {
    const post = getBlogPost(params.slug);
    if (!post) throw notFound();
    return { post };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return { meta: [{ title: "Post not found" }] };
    const p = loaderData.post;
    const path = `/${p.slug}/`;
    const base = pageMeta({
      path,
      title: `${p.title} | ${siteConfig.name}`,
      description: p.dek,
      image: p.heroImage.src.startsWith("http") ? p.heroImage.src : `https://optimizeplus.net${p.heroImage.src}`,
      type: "article",
      keywords: p.tags,
    });

    const faqs = p.sections
      .filter(s => s.h.toLowerCase().includes('faq') || s.h.includes('?'))
      .map(s => ({ q: s.h, a: s.p.join(' ') }));

    return {
      ...base,
      scripts: ldScripts(
        blogPostingLd({
          headline: p.title,
          description: p.dek,
          path,
          datePublished: p.publishedISO,
          dateModified: p.updatedISO || p.publishedISO,
          authorName: siteConfig.founder.name,
          image: p.heroImage.src,
          keywords: p.tags,
          faqs: faqs.length > 0 ? faqs : undefined,
        }),
        breadcrumbLd([
          { name: "Home", path: "/" },
          { name: "Blog", path: "/blog/" },
          { name: p.title, path },
        ])
      ),
    };
  },
  component: () => {
    const { post } = Route.useLoaderData();
    return <BlogPostView post={post} />;
  },
});
